import axios from "axios";

import { BASE_URL } from "../../src/utils/api_base_url_configration";

// const token = localStorage.getItem("token");

// const getConfig = () => {
//   return {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       Accept: "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   };
// };
export const getTaxServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "tax/list", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};


export const addTaxServ = async (formData) => {
  try {
    const response = await axios.post(BASE_URL + "tax/create", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const updateTaxServ = async (formData) => {
  try {
    const response = await axios.put(BASE_URL + "tax/update", formData);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
export const deleteTaxServ = async (id) => {
  try {
    const response = await axios.delete(BASE_URL + "tax/delete/"+id);
    return response;
  } catch (error) {
    // Handle error (e.g., log or throw an error)
    console.error("Error fetching data:", error);
    throw error;
  }
};
